import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

// Context Providers
import { EnvironmentProvider } from './context/EnvironmentContext';
import { WorkflowProvider } from './context/WorkflowContext';

// Layout
import AppLayout from './components/Layout/AppLayout';

// Auth Components
import PrivateRoute from './components/Auth/PrivateRoute';
import PostLoginRedirectHandler from './components/Auth/PostLoginRedirectHandler';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import CallbackPage from './pages/CallbackPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import DashboardPage from './pages/DashboardPage';
import AgentsDashboardPage from './pages/AgentsDashboardPage';
import TabbedFlowEditorPage from './pages/TabbedFlowEditorPage';
import FlowEditorPage from './pages/FlowEditorPage';
import SettingsPage from './pages/SettingsPage';
import AuthLandingPage from './pages/AuthLandingPage';

function App() {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <EnvironmentProvider>
        <WorkflowProvider>
          <Router>
            <PostLoginRedirectHandler />
            <Routes>
              {/* Set FlowEditor as default and explicit route */}
              <Route path="/" element={
                <PrivateRoute>
                  <AppLayout>
                    <TabbedFlowEditorPage />
                  </AppLayout>
                </PrivateRoute>
              } />
              <Route path="/flow-editor" element={
                <PrivateRoute>
                  <AppLayout>
                    <TabbedFlowEditorPage />
                  </AppLayout>
                </PrivateRoute>
              } />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/callback" element={<CallbackPage />} />
              <Route path="/accept-invite" element={<AcceptInvitePage />} />
              {/* Remove AuthLandingPage and password-only page routes */}
              {/* Remove or redirect landing page to workflow editor */}
              <Route path="/landing" element={<Navigate to="/flow-editor" replace />} />
              {/* Protected routes */}
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <AppLayout>
                      <DashboardPage />
                    </AppLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/agents"
                element={
                  <PrivateRoute>
                    <AppLayout>
                      <AgentsDashboardPage />
                    </AppLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <AppLayout>
                      <SettingsPage />
                    </AppLayout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/flow-editor/:workflowId"
                element={
                  <PrivateRoute>
                    <AppLayout>
                      <FlowEditorPage />
                    </AppLayout>
                  </PrivateRoute>
                }
              />
              {/* Fallback route: redirect all unknown routes to flow-editor */}
              <Route path="*" element={<Navigate to="/flow-editor" replace />} />
            </Routes>
          </Router>
        </WorkflowProvider>
      </EnvironmentProvider>
    </SnackbarProvider>
  );
}

export default App;